import {Pinia} from 'pinia'
import {useWorkspaceStore} from '@toolify/client/src/stores/WorkspaceStore/useWorkspaceStore'
import {usePermissionApiStore} from '@toolify/client/src/stores/api/PermissionApiStore/usePermissionApiStore'
import {ResourceType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/ResourceType'
import {RouteName} from '@toolify/client/src/setup/router/enum/RouteName'
import {LocalPreferenceType} from '@toolify/client/src/stores/LocalPreferenceStore/enum/LocalPreferenceType'
import {useLocalPreferenceStore} from '@toolify/client/src/stores/LocalPreferenceStore/useLocalPreferenceStore'
import * as Sentry from '@sentry/vue'

export async function restoreWorkspaceContext(pinia?: Pinia) {
  const workspaceStore = useWorkspaceStore(pinia)
  if(workspaceStore.currentWorkspace?.id) {
    return
  }
  await workspaceStore.ensureMyWorkspaces()
  const workspaces = workspaceStore.myWorkspaces ?? []
  if(!workspaces.length) {
    return {
      name: RouteName.ChooseWorkspace,
    }
  }
  const localPreferenceStore = useLocalPreferenceStore(pinia)
  const lastWorkspaceName = localPreferenceStore.get(LocalPreferenceType.LastWorkspaceName)
  const workspace = workspaces.find(workspaceInstance => workspaceInstance.name === lastWorkspaceName) ?? workspaces[0]
  const permissionApiStore = usePermissionApiStore(pinia)
  try {
    const {permissions} = await permissionApiStore.getUserPermissionMapByResource(
      ResourceType.Workspace,
      workspace.id,
    )
    workspaceStore.currentWorkspace = workspace
    workspaceStore.setCurrentWorkspacePermissionMap(permissions)
    void localPreferenceStore.set(LocalPreferenceType.LastWorkspaceName, workspace.name)
  } catch(error) {
    Sentry.captureException(error)
    return {
      name: RouteName.ChooseWorkspace,
    }
  }
}
